var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pipeline-menu-item-position caption",class:{
    'pipeline-menu-item-position--visited': _vm.isVisited,
    'pipeline-menu-item-position--current': _vm.isCurrent && !_vm.isVisited,
  },style:(_vm.cssVars)},[(_vm.isVisited)?_c('Icon',{staticClass:"pipeline-menu-item-position__icon",attrs:{"name":"check","size":20}}):_c('span',[_vm._v(_vm._s(_vm.position))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }